import Editor from "components/Editor";

function App() {
  return (
    <div className="app">
      <Editor />
    </div>
  );
}

export default App;
